import {main} from '@popperjs/core';
import {bootstrap , Tooltip } from 'bootstrap';

import 'particles.js'
// import particlesJS from 'particles.js/particles';

import Swiper from 'swiper';
// import 'swiper/css';

//gLightbox
import AOS from 'aos';
import GLightbox from 'glightbox';
import {setupRecaptcha} from "./recaptcha";
import {initiateCookieConsent} from "./cookie-consent";

GLightbox({
    selector: ".glightbox",
});

setupRecaptcha();

AOS.init();

//nav bg on scroll
const mainNav = document.getElementById('main-nav');
const heroBg = document.getElementById('particles-js');
let scrollpos = window.scrollY;
let body = document.body;

const add_body_on_scroll = () => body.classList.add("scrolled-body");
const remove_body_on_scroll = () => body.classList.remove("scrolled-body");

if (heroBg && mainNav) {
    //add/remove on load
    document.addEventListener('DOMContentLoaded', function () {
        if (window.pageYOffset >= heroBg.offsetTop + heroBg.offsetHeight) {
            add_body_on_scroll();
        } else {
            remove_body_on_scroll();
        }
    });
}

if (mainNav) {

    //on scroll
    window.addEventListener('scroll', () => {
        scrollpos = window.scrollY;

        if (scrollpos >= 1) {
            add_body_on_scroll();
        } else {
            remove_body_on_scroll();
        }
    });
}

//Swiper
const swiper = new Swiper(".featured-project-slider", {
    spaceBetween: 50,
    loop: true,
    autoplay: {
        delay: 6000,
    }
});
//swiper next
const swiperNext = Array.from(document.getElementsByClassName('swiper-next'));
if (swiperNext){
    swiperNext.forEach(next => {
        next.addEventListener('click', function handleClick() {
            swiper.slideNext();
        });
    });
}

let particles = document.querySelectorAll(".bg-particles");
let index = 0;
(function loopIt(index) {
    if (index >= particles.length) return;

    let bgParticles = particles[index];
    let delay = bgParticles.dataset.delay ?? 0;
    if (delay > 0) {
        setTimeout(function () {
            initParticles(bgParticles);
        }, delay);
    } else {
        initParticles(bgParticles);
        loopIt(index + 1);
    }

})(index)

function initParticles(bgParticles) {
    let color = bgParticles.dataset.color ?? "#fff";
    let nodes = bgParticles.dataset.nodes ?? 100;
    let lineWidth = bgParticles.dataset.lineWidth ?? 1;
    let lineOpacity = bgParticles.dataset.lineOpacity ?? 0.4;
    let circleStroke = bgParticles.dataset.circleStroke ?? 0;
    particlesJS(bgParticles.id, {
        "particles": {
            "number": {"value": nodes, "density": {"enable": true, "value_area": 1262.6362266116362}},
            "color": {"value": color},
            "shape": {
                "type": "circle",
                "stroke": {"width": circleStroke, "color": color},
                "polygon": {"nb_sides": 9},
                "image": {"src": "img/github.svg", "width": 100, "height": 100}
            },
            "opacity": {
                "value": 0.5,
                "random": false,
                "anim": {"enable": false, "speed": 1, "opacity_min": 0.1, "sync": false}
            },
            "size": {
                "value": 3.945738208161363,
                "random": true,
                "anim": {"enable": false, "speed": 38.977490499236644, "size_min": 0.1, "sync": false}
            },
            "line_linked": {
                "enable": true,
                "distance": 150,
                "color": color,
                "opacity": lineOpacity,
                "width": lineWidth
            },
            "move": {
                "enable": true,
                "speed": 6,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {"enable": false, "rotateX": 600, "rotateY": 1200}
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {"onhover": {"enable": true, "mode": "repulse"}, "onclick": {"enable": false}, "resize": true},
            "modes": {
                "grab": {"distance": 400, "line_linked": {"opacity": 1}},
                "bubble": {
                    "distance": 575.4245754245754,
                    "size": 59.940059940059946,
                    "duration": 2,
                    "opacity": 8,
                    "speed": 3
                },
                "repulse": {"distance": 151.84815184815184, "duration": 0.4},
                "push": {"particles_nb": 4},
                "remove": {"particles_nb": 2}
            }
        },
        "retina_detect": true
    });
}

let forms = document.querySelectorAll('.needs-validation')

Array.prototype.slice.call(forms)
    .forEach(function (form) {
        form.addEventListener('submit', function (event) {
            if (!form.checkValidity()) {
                event.preventDefault()
                event.stopPropagation()
            }

            form.classList.add('was-validated')
        }, false)
    })


//Navbar active state
let currentUrl = window.location.pathname;
let navLinks = document.querySelectorAll('header .navbar-nav .nav-link');
navLinks.forEach(function (link) {
    let linkUrl = link.getAttribute('href');
    if ((currentUrl.includes(linkUrl) && linkUrl != "/") || (currentUrl == "/" && linkUrl == "/")) {
        link.classList.add('active');
    }
    else{
        link.classList.remove('active');
    }
});

let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
})


initiateCookieConsent();